import { LivechatConversationModel } from '@mm/state/model/LivechatConversationModel';
import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import { useCountdownTimer } from '../../../../../../common/hooks/use-countdown-timer';
import { getFormattedDate } from '../../../shared';
import { INDEFINITELY } from '../../MessageSender/BotPausing';
import '../Conversations.pcss';

export const PausedStatus = ({
  conversation,
  showDateFallback,
  className,
}: {
  conversation: Pick<LivechatConversationModel, 'mutedTill' | 'time'>;
  showDateFallback?: boolean;
  className?: string;
}) => {
  const endTime =
    conversation.mutedTill && Number(conversation.mutedTill)
      ? Number(conversation.mutedTill)
      : undefined;

  const countDown = useCountdownTimer(endTime, true);
  const isIndefinitely = !!(
    endTime && endTime - moment().valueOf() > INDEFINITELY
  );
  const containerClassName = classNames(
    'live-chat--conversation__bot-pausing',
    className,
  );

  if (countDown) {
    return (
      <div className={containerClassName}>
        <i className="fas fa-pause live-chat--conversation__bot-pausing_icon" />
        {!isIndefinitely && (
          <span className="live-chat--conversation__bot-pausing_title">
            {countDown}
          </span>
        )}
      </div>
    );
  }
  if (showDateFallback) {
    return <>{getFormattedDate(Number(conversation.time))}</>;
  }
  return null;
};
